import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ maxHeightTable }: Theme) => ({
  tableContainer: {
    maxHeight: maxHeightTable,
    margin: '0 20px',
    width: 'calc(100% - 40px)',
  },
  buttonsTableCell: {
    padding: 5,
    width: 100,
    minWidth: 100,
  },
  bold: {
    fontWeight: 'bold',
  },
  deleteIcon: {
    color: '#ee6d59',
  },
  editIcon: {
    color: '#636dde',
  },
  wrap: {
    maxWidth: 400,
    wordWrap: 'break-word',
  },
}));
